<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/height.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <div>Height</div>
  </app-access-item-header>

  <app-access-item-cta>
    <div class="buttons">
      @for (height of heights; track height.label) {
        <button
          appButton
          [name]="'height_' + height.label"
          location="theme-section-width-item"
          [color]="theme().cover.size === height.value ? 'simple-primary-opacity' : 'simple-gray-50'"
          [class.constant]="theme().cover.size === height.value"
          (click)="updateHeight(height.value)"
          shape="round"
          height="0-5"
          spacing="1"
        >
          {{ height.label }}
        </button>
      }
    </div>
  </app-access-item-cta>
</app-access-item>
